export default "__VITE_ASSET__D09ilr39__"